import { render, staticRenderFns } from "./AppDrawer.vue?vue&type=template&id=f8843dc4&scoped=true&lang=pug&"
import script from "./AppDrawer.vue?vue&type=script&lang=ts&"
export * from "./AppDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8843dc4",
  null
  
)

export default component.exports